module.exports = __webpack_public_path__ + "static/lighting-table-expandable-headless-4b5ce00d01823e117b517c96220041ed.png";